import { apiFetch as authenticatedFetch } from '../services/auth';

/**
 * JSON flavour of the shared authenticated fetch.
 *
 * Session-expiry handling lives in services/auth. This module used to carry a
 * second copy of it that cleared the session without ever marking it expired
 * and without redirecting, so a session that died on one of these calls left
 * the UI silently stuck — no "please sign in again", just a screen that stopped
 * responding. Delegate instead, and keep only the JSON defaulting its callers
 * rely on.
 */
export function apiFetch(url: string, init: RequestInit = {}): Promise<Response> {
  const headers: Record<string, string> = { ...(init.headers as Record<string, string> | undefined) };
  const labelled = Object.keys(headers).some((key) => key.toLowerCase() === 'content-type');

  // Several callers post a JSON body without labelling it themselves.
  if (!labelled && init.body !== undefined) {
    headers['Content-Type'] = 'application/json';
  }

  return authenticatedFetch(url, { ...init, headers });
}
